import {
    HrSimulation,
    SimulationDateString,
} from 'routes/HumanResourcesModule/Simulation/helpers/types';

export const isDateInvalid = ({
    gradeStartDate,
    startDate,
    endDate,
}: {
    gradeStartDate: SimulationDateString;
    startDate: SimulationDateString;
    endDate: SimulationDateString;
}) => {
    const dateTimestamp = Date.parse(gradeStartDate);
    const startDateTimestamp = Date.parse(startDate);
    const endDateTimestamp = Date.parse(endDate);

    if (
        isNaN(dateTimestamp) ||
        dateTimestamp > endDateTimestamp ||
        startDateTimestamp > dateTimestamp
    ) {
        return true;
    }
    return false;
};

export const isValidGradeAvancementHypothesis = ({
    hrSimulation,
    grade,
    echelon,
    gradeStartDate,
}: {
    hrSimulation: HrSimulation;
    grade: string;
    echelon: string;
    gradeStartDate: SimulationDateString;
}): boolean =>
    !!grade &&
    !!echelon &&
    gradeStartDate &&
    !isDateInvalid({
        gradeStartDate,
        startDate: hrSimulation.startDate,
        endDate: hrSimulation.endDate,
    });
